import { luscinia } from "./luscinia";
import { dataURLToFile } from "./Utils/dataUrlToFile";

luscinia.postFormData = function (url, form) {
    if (!form.is("form")) {
        new Error("Element has to be html <form> element")
    }

    return $.ajax({
        method: "POST",
        processData: false,
        contentType: false,
        url: url,
        data: luscinia.serializeFormObject(form)
    });
}

luscinia.getLocalizedElementValue = function (element: JQuery<HTMLElement>): string {
    if ($(element).hasClass("inputmask")) {
        return $(element).val() as string;
    }
    else if ($(element).hasClass("datetime")) {
        $(element).data("DateTimePicker").date().format()
    }
    else if ($(element).is(':checked')) {
        let value = $(element).is(':checked');
        return value.toString();
    }
    else if ($(element).parent().hasClass("datetime")) {
        const dateString = $(element).val() as string;
        if (dateString.includes('-')) {
            const [day, month, year] = dateString.split('-');
            const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
            const isoString = date.toISOString();
            return isoString;
        }
        else {
            return dateString;
        }
    }
    return $(element).val() as string;
}

luscinia.serializeFormElements = function (form) {
    var serializeData = [];

    $(form).find("input:disabled[name]").each(function (i, element) {
        var name = $(this).attr('name') as string;
        var value = $(this).val() as string;

        if (value == null) return;

        serializeData.push({ name: name, value: value });
    });

    $(form).find(".inputmask").each(function (i, element) {
        var name = $(this).attr('name') as string;
        var value = $(this).val() as string;
        if (value) {
            serializeData.push({ name: name, value: value });
        }
    });

    $(form).find(".datetime").each(function (index, element) {
        if ($(this).data("DateTimePicker") !== undefined && $(this).data("DateTimePicker").date() !== null) {
            var name = $(this).find("input").attr('name') as string;
            var value = $(this).data("DateTimePicker").date().format();
            serializeData.push({ name: name, value: value });
        }
    });

    $(form).find("input[type=checkbox]").each(function (index, element) {
        let value = $(element).is(':checked');
        let name = $(element).attr("name");
        if (value !== undefined) {
            serializeData.push({ name: name, value: value.toString() });
        }
    });

    $(form).find("." + luscinia.css.bootgrid).each(function () {
        var fieldName = $(this).data(luscinia.data.fieldName);
        var bootgridArray = luscinia.bootgridSelectedRowsToArray($(this));
        if (bootgridArray.length > 0) {
            serializeData.push({ name: fieldName, value: bootgridArray.toString() });
        }
    });

    $(form).find(".select2-multi-select").each((i, el) => {
        const fieldName = el.getAttribute("name");
        const value = ($(el) as any).select2("data").map(d => d.id).join(",");
        serializeData.push({ name: fieldName, value: value })
    })

    $(form).find("input[type=file]").each((index, element) => {
            const fieldName = element.getAttribute("name");
            const value = element.getAttribute("value");

            const files = (element as HTMLInputElement).files;
            const hasFile = files && files.length > 0;
            if (value && !hasFile) {
                serializeData.push({ name: fieldName, value: value })
            }
        }
    );

    serializeMultiSelectInputs(form, serializeData);

    return serializeData;
};

luscinia.serializeFormObject = function (form) {
    var serializeData = new FormData($(form)[0]);
    var elementsData = luscinia.serializeFormElements(form);
    elementsData.forEach(item => {
        serializeData.set(item.name, item.value);
    });

    $(form).find('.bsignature').each(function () {
        const signaturePad = $(this).data('signaturePad') as SignaturePad;
        if (signaturePad) {
            const signatureDataUrl = signaturePad.toDataURL();
            const file = dataURLToFile(signatureDataUrl, 'signature.png');
            const relatedInputName = $(this).data('luscinia-relatedinput');
            serializeData.delete(relatedInputName + '-signature');
            serializeData.append(relatedInputName, file);
        }
    });

    return serializeData;
};

luscinia.bootgridSelectedRowsToArray = function (bootgrid) {
    var idList: any = [];
    bootgrid.find("tbody tr." + luscinia.css.rowSelected).each(function () {
        idList.push($(this).data("row-id"));
    });
    return idList;
};

function serializeMultiSelectInputs(form: JQuery<HTMLElement>, serializeData: any[]) {
    const properties = new Set<string>();
    $(form).find(".luscinia-multi-select-input").each((i, el) => {
        properties.add(el.dataset.propertyToBind);
    });
    const uniquePropertiesArray = Array.from(properties);

    uniquePropertiesArray.forEach((property) => {
        const inputs = $(form).find(
            `.luscinia-multi-select-input[data-property-to-bind="${property}"] input.form-check-input:checked`
        ) as JQuery<HTMLInputElement>;

        const value = inputs
            .toArray()
            .map((input) => input.value)
            .join(",");

        serializeData.push({ name: property, value });
    });
}
